import { FC, memo } from 'react';
import { isEqual } from 'lodash';
import styled from 'styled-components';
import { List, ListSubheader, ListItem } from '@material-ui/core';
import { Entry } from '../services/DataService';
import CustomListItem from './CustomListItem';

type CustomListProps = {
    title: string;
    data: Entry[];
    onClick: (id: number, selected: boolean) => void;
};

const Wrapper = styled.div`
    flex: 1;
`;

const Section = styled.div`
    background-color: ${({ theme }) => theme.palette.background.default};
    font-size: 1.2rem;
    border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
    color: ${({ theme }) => theme.palette.text.primary};
`;

const areEqual = (
    prevProps: CustomListProps,
    nextProps: CustomListProps
): boolean => {
    return isEqual(prevProps.data, nextProps.data);
};

const CustomList: FC<CustomListProps> = ({ title, data, onClick }) => {
    return (
        <List>
            {title !== 'undefined' ? (
                <>
                    <span id={title}></span>
                    <ListSubheader>
                        <Section>{title}</Section>
                    </ListSubheader>
                </>
            ) : null}
            {data.map((entry, index) => (
                <ListItem key={index}>
                    <Wrapper>
                        <CustomListItem
                            key={entry.id}
                            data={entry}
                            onClick={onClick}
                        />
                    </Wrapper>
                </ListItem>
            ))}
        </List>
    );
};

export default memo(CustomList, areEqual);
